


<template>
  <div>
    <div
      class="circle flex-h"
      @click="handleClick(isUp)"
      :class="isUp ? 'check' : ''"
      style="float: left"
    >
      <div class="img-box" :class="isUp ? 'img-box-check' : ''">
        <img v-if="isUp" src="@/assets/images/dian.png" alt="" />
        <img v-else src="@/assets/images/dian1.png" alt="" />
      </div>
    </div>

    <div style="float: left; margin-top: 5px; margin-right: 20px">
      <span> {{ likeNum }} 点赞 </span>
    </div>

    <div class="linkTop">
      <img src="@/assets/images/yan.png" alt="" />
      <span> {{ browseNum }} 浏览量 </span>
    </div>
  </div>
</template>
<script>
export default {
  //          浏览量   点赞数量 是否点赞
  props: ["browseNum", "likeNum", "isUp"],
  data() {
    return {
      //  isUp: ""
    };
  },
  methods: {
    handleClick(isUp) {
      if (localStorage.getItem("token")) {
        if (isUp) {
          this.$emit("unThumbsUpFn");
          this.isUp = false;
          // this.likeNum--;
        } else {
          this.$emit("thumbsUpFn");
          this.isUp = true;
          // this.likeNum++;
        }
      } else {
        this.$message({ type: "error", message: "请先登录!" });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.linkTop {
  float: left;
  margin-right: 20px;
  margin-top: 5px;
  img {
    vertical-align: bottom;
    width: 20px;
    height: 20px;
  }
}
.circle {
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0px 0px 0px 0px rgba(223, 46, 58, 0.5);
  .img-box {
    width: 20px;
    height: 20px;
    margin: 5px;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    user-select: none; // 防止快速点击图片被选中，可不加，为提高体验，博主加上了这几行代码。
    & img {
      width: 100%;
      height: 100%;
    }
  }
}
.check {
  -webkit-transition: box-shadow 0.5s;
  -moz-transition: box-shadow 0.5s;
  -o-transition: box-shadow 0.5s;
  transition: box-shadow 0.5s;
  box-shadow: 0px 0px 0px 1em rgba(226, 32, 44, 0);
}
.img-box-check {
  animation: anm 0.5s;
  -moz-animation: anm 0.5s;
  -webkit-animation: anm 0.5s;
  -o-animation: anm 0.5s;
}
@keyframes anm {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -moz-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
  }
}

// 以下为处理兼容代码，可不看。

@-moz-keyframes anm {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -moz-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
  }
}

@-webkit-keyframes anm {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -moz-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
  }
}

@-o-keyframes anm {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -moz-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
  }
}
</style>